import styled, { css } from 'styled-components';
import { MenuBarProps } from '../menuTypes';

/**
 * Topbar styled component that serves as the container for the top menu.
 */
export const Topbar = styled.nav<MenuBarProps>`
	position: relative;
	margin: 0;
	flex: 1;
	box-sizing: border-box;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 1rem;
	overflow: hidden;

	${({ $w, $h, $bg, theme }) => {
		const { colors } = theme;
		return css`
			height: ${$h};
			width: ${$w};
			background: '${colors[$bg] || $bg}';
		`;
	}}
`;
